var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @file TableCheckable组件
 * @author (wangzichuan)
 */
import React, { Component } from 'react';
import _ from 'lodash';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import Table from '../Table';
import TableBody from '../TableBody';
import TableRow from '../TableRow';
import TableCell from '../TableCell';
import Checkbox from '../../Checkbox/Checkbox';

import './TableCheckable.less';

var TableCheckable = function (_Component) {
    _inherits(TableCheckable, _Component);

    function TableCheckable() {
        _classCallCheck(this, TableCheckable);

        return _possibleConstructorReturn(this, (TableCheckable.__proto__ || Object.getPrototypeOf(TableCheckable)).apply(this, arguments));
    }

    _createClass(TableCheckable, [{
        key: 'tabelCheckableBody',
        value: function tabelCheckableBody() {
            var _props = this.props,
                data = _props.data,
                columnConfigs = _props.columnConfigs,
                uniqueKeyName = _props.uniqueKeyName;

            return React.createElement(
                TableBody,
                null,
                data.map(function (rowData, rowIndex) {
                    return React.createElement(
                        TableRow,
                        { key: rowData[uniqueKeyName] },
                        columnConfigs.map(function (colConfig, colIndex) {
                            var refer = colConfig.refer,
                                render = colConfig.render,
                                checkable = colConfig.checkable,
                                onCheck = colConfig.onCheck;

                            var checkboxProps = {
                                className: 'table-checkbox',
                                checked: rowData.checked,
                                disabled: rowData.disabled || false,
                                control: true,
                                getValue: function getValue() {
                                    _.isFunction(onCheck) && onCheck({
                                        rowData: rowData
                                    });
                                }
                            };
                            return React.createElement(
                                TableCell,
                                { key: colIndex },
                                checkable && React.createElement(Checkbox, checkboxProps),
                                _.isFunction(render) ? render(rowData[refer], rowIndex, rowData, data) : rowData[refer]
                            );
                        })
                    );
                })
            );
        }
    }, {
        key: 'headerChecked',
        value: function headerChecked() {
            var data = this.props.data;
            var checkedData = data.filter(function (rowData) {
                return rowData.checked;
            });
            if (checkedData.length === 0) {
                // 取消
                return false;
            } else if (checkedData.length === data.length) {
                // 全选
                return true;
            } else {
                // 选择部分
                return -1;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this,
                _classnames;

            var columnConfigs = _.cloneDeep(this.props.columnConfigs);
            var onCheck = columnConfigs[0].onCheck;
            var checkboxProps = {
                className: 'table-checkbox',
                control: true,
                checked: this.headerChecked(),
                getValue: function getValue() {
                    _.isFunction(onCheck) && onCheck({
                        headerCheckbox: true,
                        currentChecked: _this2.headerChecked()
                    });
                }
            };
            columnConfigs[0].title = [React.createElement(Checkbox, _extends({ key: 'checkbox' }, checkboxProps)), columnConfigs[0].title];
            return React.createElement(
                Table,
                _extends({}, this.props, {
                    columnConfigs: columnConfigs,
                    className: classnames((_classnames = {}, _defineProperty(_classnames, this.props.className, this.props.className), _defineProperty(_classnames, 'table-checkable', true), _classnames))
                }),
                this.tabelCheckableBody()
            );
        }
    }]);

    return TableCheckable;
}(Component);

TableCheckable.propTypes = {
    data: PropTypes.array,
    columnConfigs: PropTypes.array,
    uniqueKeyName: PropTypes.string,
    className: PropTypes.string,
    onCheck: PropTypes.func
};
TableCheckable.defaultProps = {
    data: [],
    columnConfigs: [],
    uniqueKeyName: 'id'
};
export default TableCheckable;